import React from 'react';
import styled from 'styled-components';
import { vars } from '../../theme';
import HBText from '../HBText/HBText';
import { flexColumn } from '../../styles/mixins';

interface Props {
    title: string;
    subtitle: string;
    columnsCount: number;
}

const HBNewTableNoResults = ({ title, subtitle, columnsCount }: Props) => {
    return (
        <tbody>
            <tr>
                <td colSpan={columnsCount}>
                    <Container>
                        <HBText type="body18">{title}</HBText>
                        <HBText type="body14" color="text.tertiary">
                            {subtitle}
                        </HBText>
                    </Container>
                </td>
            </tr>
        </tbody>
    );
};

export default HBNewTableNoResults;

// --- Styles ---

export const NewTableStyledTbody = styled.tbody``;

const Container = styled.div`
    ${flexColumn};
    padding: 32px 0;
    margin-top: 12px;
    align-items: center;
    gap: 12px;
    border: 1px solid ${vars.colors.stroke.secondary};
    border-radius: ${vars.radius.xs};
`;
